import { type OidcConfiguration, TokenAutomaticRenewMode } from '@axa-fr/react-oidc';

import { ENV_VARS } from 'app/config/environment-vars';
import type { Nullable } from 'utils/values';

const authority = ENV_VARS.IDENTITY_URL;
const clientId = ENV_VARS.CLIENT_ID;
const redirectUri = ENV_VARS.REDIRECT_URL;

export function getAuthConfig(): Nullable<OidcConfiguration> {
  if (!authority || !clientId || !redirectUri) {
    return null;
  }

  return {
    authority,
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: 'openid profile',
    silent_redirect_uri: redirectUri.replace('/callback', '/silent_renew'),
    token_automatic_renew_mode: TokenAutomaticRenewMode.AutomaticBeforeTokenExpiration,
    preload_user_info: true,
    monitor_session: true
  };
}
